import React from 'react';
import Hero from './components/tenders/Hero';
import Main from './components/tenders/Main';

const Tender = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Tender;